import { Card, HeaderMenu } from "components";
import { Filter } from "./components/Filter";
import { default_pagination_value } from "utils";
import { FilterTypeSetStockGlobal } from "pages/Inventori/Transaction/SetStockGlobal/types/SetStockGlobalTypes";
import { useState } from "react";
import { useListStockGlobal } from "./hooks/useListStockGlobal";
import { Table } from "./components/Table";

export default function ItemDetaiStockGlobal() {

    const [showMinus, setShowMinus] = useState(true)
    const [showPlus, setShowPlus] = useState(true)

    const [filter, setFilter] = useState<FilterTypeSetStockGlobal>({
        ...default_pagination_value,
        zero_soh: true,
    })

    const data = useListStockGlobal(filter)

    return(
        <section className="container my-5">
            <HeaderMenu title="ITEM DETAIL STOCK GLOBAL" className="sticky top-[32px] z-[1]" />
            <section className="my-2">
                <section className="mt-2 sticky top-[120px] z-[1]">
                    <Card>
                        <Card.Body>
                            <Filter
                                filter={filter}
                                setFilter={setFilter}
                                showMinus={showMinus}
                                setShowMinus={setShowMinus}
                                showPlus={showPlus}
                                setShowPlus={setShowPlus}
                            />
                        </Card.Body>
                    </Card>
                </section>
            </section>

            <section className="mt-2">
                <Card>
                    <Card.Body>
                       
                            <div>
                                <Table
                                    filter={filter}
                                    setFilter={setFilter}
                                    data={data}
                                    showMinus={showMinus}
                                    showPlus={showPlus}
                                />
                            </div>

                    </Card.Body>
                </Card>
            </section>

        </section>
    )
}